/*
 *   Copyright (c) 2021 Propally.Inc
 *   All rights reserved.
 */
import * as Sentry from "@sentry/browser";
import { CaptureConsole } from "@sentry/integrations";
import * as React from "react";
import * as ReactDOM from "react-dom";

import { PropallyApp } from "./app";
import {
  initializeAppMeasurementTool,
  initializeATT,
  initializePushNotification,
  isNativeApp,
} from "./utilities/capacitor_logic";

if (process.env.ENABLE_SENTRY) {
  Sentry.init({
    dsn: "https://ecf1dd4ff57d4faeb2274d0d74f78ef1@o561825.ingest.sentry.io/5802021",
    environment: process.env.SERVICE_ENVIRONMENT,
    release: process.env.GIT_COMMIT_HASH,
    integrations: [new CaptureConsole({ levels: ["error", "warn"] })],
  });
}

if(isNativeApp) {
  initializePushNotification();
  initializeAppMeasurementTool();
  initializeATT();
}

ReactDOM.render(<PropallyApp />, document.getElementById("propally-root"));
